import React from 'react';

export default () => (
  <div>
    <h1>Book de visite</h1>
    <p>
      Vous n'êtes pas autorisé à accéder au Book de visite.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./shared/src/pages/SandBoxPage.jsx